// extracted by mini-css-extract-plugin
export default {"caseSection":"CaseSection_caseSection__4BbiK","caseCards":"CaseSection_caseCards__iR9Gu","caseMore":"CaseSection_caseMore__NucEN","moreLink":"CaseSection_moreLink__aHQbO"};